const getBaseUrl = () => {
    if(window?.location?.origin){
        var base_url = window.location.origin;

        var apiUrl = `${base_url}/spiritmas2025-api`;
        return apiUrl;
    }
    else{
        return "";
    }
}

const getTemplate = () => {
    if(window?.location?.origin){
        var base_url = window.location.origin;

        var apiUrl = `${base_url}/spiritmas2025-api/public/template/spiritmas2025_user_template.xlsx`;
        return apiUrl;
    }
    else{
        return "";
    }
}


const appConfig = {
    pathUserTemplate: 'https://spiritmas2025-api.event-ku.com/public/template/spiritmas2025_user_template.xlsx',
    apiPrefix: 'https://spiritmas2025-api.event-ku.com',

    // pathUserTemplate: getTemplate(),
    // apiPrefix: getBaseUrl(),

    pathCodeTemplate: '',
    authenticatedEntryPath: '/admin-eventqiu/user',
    unAuthenticatedEntryPath: '/admin-eventqiu/sign-in',
    adminPath: '/admin-eventqiu',
    tourPath: '/',
    notFound: '/not-found',
    locale: 'en',
    enableMock: false,
}

export default appConfig
